import {List} from 'immutable';

import {coachingPlan} from '@store/coaching-plans/coaching-plans.selectors';
import {skillsByTeamList} from '@store/skills';
import {createSelector} from '@store/@common';
import Skill from 'records/Skill';

export const coachingPlanSkills = createSelector(
  [coachingPlan, skillsByTeamList],
  (plan, skillList): List<Skill> => {
    if (!plan) {
      return List();
    }

    return plan.contentDetails
      .map(detail => skillList.find(skill => skill.id === detail.skillId))
      .filter(t => !!t) as List<Skill>;
  }
);

export const coachingPlanSkillIds = createSelector([coachingPlanSkills], skills =>
  skills.map(el => el.id)
);
